import { CircularProgress } from "@mui/material";
import BoatApplication from "@poseidon/features/feature/Boats/BoatApplication";
import BoatForm from "@poseidon/features/feature/Boats/BoatForm";
import { useBoat } from "@poseidon/features/feature/Boats/useBoat";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import { useParams } from "react-router-dom";
import { useBaseRoutePathContext } from "@poseidon/utils/base-route-path";

export default function EditBoat() {
  const { setError } = useErrorMessage();
  const { boatId } = useParams();
  const { boat, loading, error } = useBoat(boatId);
  const { route: baseRoutePath } = useBaseRoutePathContext();

  useCrumb(`${baseRoutePath}/boats/:boatId`, {
    to: `${baseRoutePath}/boats/:boatId`,
    Component: () => (
      <WithDoc
        docRef={`boats/${boatId}`}
        Component={({ data: boat }) => `${boat.make} - ${boat.model}`}
      />
    ),
  });

  if (error) {
    setError(error);
  }

  if (loading || !boat) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <>
      <BoatForm boat={boat} application={boat.application} />
      <BoatApplication application={boat.application} />
    </>
  );
}
